import { DifficultyLevel } from '../../utils/advancedMultiplication';

interface AdvancedGameDisplayProps {
  question: string;
  answer: number;
  explanation?: string;
  showAnswer: boolean;
  isBlocked?: boolean;
  level: DifficultyLevel;
}

const funnyMessages = [
  "Your brain needs a quick recharge! 🔋",
  "Even math wizards need breaks! 🧙‍♂️",
  "Calculations loading... Please wait! ⚡",
  "Time for a mini math meditation! 🧘‍♂️",
  "Your enthusiasm is amazing! Take a tiny break! 🌟",
  "Multiplying at warp speed? Let's slow down! 🚀",
  "The numbers request a moment of peace! 📊",
  "Math magic in progress... ✨"
];

const levelColors = {
  beginner: 'from-green-600 to-emerald-600 dark:from-green-400 dark:to-emerald-400',
  intermediate: 'from-amber-600 to-orange-600 dark:from-amber-400 dark:to-orange-400',
  expert: 'from-red-600 to-rose-600 dark:from-red-400 dark:to-rose-400'
};

const levelBgColors = {
  beginner: 'from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20',
  intermediate: 'from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20',
  expert: 'from-red-50 to-rose-50 dark:from-red-900/20 dark:to-rose-900/20'
};

const levelBorderColors = {
  beginner: 'border-green-100 dark:border-green-800',
  intermediate: 'border-amber-100 dark:border-amber-800',
  expert: 'border-red-100 dark:border-red-800'
};

export const AdvancedGameDisplay: React.FC<AdvancedGameDisplayProps> = ({
  question,
  answer,
  explanation,
  showAnswer,
  isBlocked,
  level
}) => {
  const randomMessage = () => funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  return (
    <div className="text-center mb-8">
      <div className={`bg-gradient-to-br ${levelBgColors[level]} p-8 rounded-xl border ${levelBorderColors[level]} transition-colors duration-200`}>
        <h2 className={`text-5xl font-bold mb-4 bg-gradient-to-r ${levelColors[level]} bg-clip-text text-transparent`}>
          {question} = {showAnswer ? answer : '?'}
        </h2>
        
        {showAnswer && explanation && (
          <p className="mt-4 text-lg text-gray-700 dark:text-gray-300">
            {explanation}
          </p>
        )}
        
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mt-4">
          {isBlocked ? (
            <span className="text-amber-600 dark:text-amber-400">{randomMessage()}</span>
          ) : (
            showAnswer ? 'Press → or Space for next question' : 'Press → or Space to see answer'
          )}
        </p>
      </div>
    </div>
  );
};